import { render, staticRenderFns } from "./updatePwdModal.vue?vue&type=template&id=2767a6d8&scoped=true&"
import script from "./updatePwdModal.vue?vue&type=script&lang=js&"
export * from "./updatePwdModal.vue?vue&type=script&lang=js&"
import style0 from "./updatePwdModal.vue?vue&type=style&index=0&id=2767a6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767a6d8",
  null
  
)

export default component.exports